import Errors from './Errors';
import { apiVersion } from './main.js';

class Form {
    /**
     * Create a new Form instance.
     *
     * @param {object} data
     */
    constructor(data) {
        this.originalData = data;

        for (let field in data) {
            this[field] = data[field];
        }

        this.errors = new Errors();
        this.retorno = {};
        if (process.env.VUE_APP_ENV == 'dsv') {
            this.http_version = 'http://';
        } else {
            this.http_version = 'https://';
        }
    }


    /**
     * Fetch all relevant data for the form.
     */
    data() {
        let data = {};

        for (let property in this.originalData) {
            data[property] = this[property];
        }

        return data;
    }


    /**
     * Reset the form fields.
     */
    reset() {
        for (let field in this.originalData) {
            this[field] = '';
        }

        this.errors.clear();
    }
    /**
     * Send a POST request to the given URL.
     * .
     * @param {string} url
     */
    post(url) {
        return this.submit('post', (process.env.VUE_APP_ENV === 'dsv' ? process.env.VUE_APP_ENDPOINT : this.http_version + (apiVersion() === 2 ? process.env.VUE_APP_ENDPOINT_LARAVEL : process.env.VUE_APP_ENDPOINT)) + url);
    }
    /**
     * Send a POST request to the given URL.
     * .
     * @param {string} url
     */
    get(url) {
        try {
            return this.submit('get', (process.env.VUE_APP_ENV === 'dsv' ? process.env.VUE_APP_ENDPOINT : this.http_version + (apiVersion() === 2 ? process.env.VUE_APP_ENDPOINT_LARAVEL : process.env.VUE_APP_ENDPOINT)) + url);
        } catch (teste) {
            return this.submit('get', (process.env.VUE_APP_ENV === 'dsv' ? process.env.VUE_APP_ENDPOINT : this.http_version + process.env.VUE_APP_ENDPOINT) + url);
        }
    }

    /**
     * Send a PUT request to the given URL.
     * .
     * @param {string} url
     */
    put(url) {
        return this.submit('put', (process.env.VUE_APP_ENV === 'dsv' ? process.env.VUE_APP_ENDPOINT : this.http_version + (apiVersion() === 2 ? process.env.VUE_APP_ENDPOINT_LARAVEL : process.env.VUE_APP_ENDPOINT)) + url);
    }


    /**
     * Send a PATCH request to the given URL.
     * .
     * @param {string} url
     */
    patch(url) {
        return this.submit('patch', (process.env.VUE_APP_ENV === 'dsv' ? process.env.VUE_APP_ENDPOINT : this.http_version + (apiVersion() === 2 ? process.env.VUE_APP_ENDPOINT_LARAVEL : process.env.VUE_APP_ENDPOINT)) + url);
    }


    /**
     * Send a DELETE request to the given URL.
     * .
     * @param {string} url
     */
    delete(url) {
        return this.submit('delete', (process.env.VUE_APP_ENV === 'dsv' ? process.env.VUE_APP_ENDPOINT : this.http_version + (apiVersion() === 2 ? process.env.VUE_APP_ENDPOINT_LARAVEL : process.env.VUE_APP_ENDPOINT)) + url);
    }


    /**
     * Submit the form.
     *
     * @param {string} requestType
     * @param {string} url
     */
    submit(requestType, url) {
        return new Promise((resolve, reject) => {
            axios[requestType](url, this.data(), {
                timeout: 300000,
                maxContentLength: 10 * 1024 * 1024,
                withCredentials: true,
            })
                .then(response => {

                    this.onSuccess(response.data);
                    // Retorna o http status

                    if (response.status != 204) {
                        response.data.httpStatus = response.status;
                    }
                    resolve(response.data);
                })
                .catch(error => {
                    // Caso seja erro de não autorizado ( 401 ) vai redirecionar para tela de login
                    if (error.response.status == 401) {
                        console.log(error);
                        //window.location.replace("/?status=401");
                    }

                    if (error.response.data.type == 3) {
                        this.onFail(error.response.data);

                        reject(error.response.data.errors);
                    }
                    else {
                        reject(error.response.data);
                    }

                });
        });
    }


    /**
     * Handle a successful form submission.
     *
     * @param {object} data
     */
    onSuccess(data) {
        //this.reset();
    }


    /**
     * Handle a failed form submission.
     *
     * @param {object} errors
     */
    onFail(errors) {
        this.errors.record(errors.errors, errors.message, errors.type);
    }
}


export default Form;
